/* eslint-disable camelcase */
import React, { FC, useEffect } from 'react';
import { useLangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import {
  setInitialLanguageCookie,
  getInitialLangCookie,
} from '../../lib/helpers';
import { useTranslationsContext } from '../../lib/translation';
import { useGTM, useRemoveBackgroundCards, useSetTitle } from '../../lib/hooks';

type Props = {
  returnUrl: string;
}

const LoginComponent: FC<Props> = ({
  returnUrl,
}) => {
  const lang = useLangContext();
  const translations = useTranslationsContext();
  useEffect(() => {
    const changeLanguageStatic = document.getElementById('change-language');
    const englishInPathName = window.location.pathname === '/en';
    if (!getInitialLangCookie()) {
      if (changeLanguageStatic) {
        const hrefLang = changeLanguageStatic.getAttribute('href');
        changeLanguageStatic.addEventListener('click', () => {
          setInitialLanguageCookie(hrefLang?.includes('en') ? 'en' : 'da');
        });
      }
      setInitialLanguageCookie(englishInPathName ? 'en' : 'da');
    }
  }, []);

  const {
    page: {
      login,
    },
    login: {
      login: {
        header: lHeader,
        link_text: lLink_text,
      },
    },
  } = translations;

  useSetTitle(login);
  useRemoveBackgroundCards(false, true);
  useGTM('virtualPageview', true, {
    pageTitle: 'My Application - Login',
    pageUrl: window.location.href,
    userContext: null,
    lang,
  });

  return (
    <div className="page__content__block page__content__block--center-align-items">
      <h1 className="text--strong" dangerouslySetInnerHTML={{ __html: lHeader }} />
      <a id="login-btn" className="button button--large" data-gtm="mian-a-login-primary" href={`/auth/login?ReturnUrl=${returnUrl}`}>{lLink_text}</a>
    </div>
  );
};

LoginComponent.displayName = 'LoginComponent';
export default LoginComponent;
